import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { IconComponent } from 'components/layout/icon/icon.component';
import { SelectListItemModel } from 'models/SelectList';
import { TaskActionModel } from 'models/generated/Entities.GormCrm.TaskAction';
import { TranslatePipe } from 'pipes/translate.pipe';
import { TaskService } from 'services/task.service';

@Component({
	selector: 'add-task-action',
	templateUrl: './add-task-action.component.html',
	imports: [IconComponent, CustomSelectComponent, TranslatePipe]
})

export class AddTaskActionComponent {
	@ViewChild('selectTaskActionType') selectTaskActionType?: CustomSelectComponent;
	@Output() createNewTaskAction = new EventEmitter<TaskActionModel>();

	newTaskAction?: TaskActionModel;
	taskTypeList: SelectListItemModel[] = [];
	showTaskActionSelect = false;
	
	constructor(private readonly taskService: TaskService) {
		this.taskTypeList = this.taskService.getTaskActionTypes();
	}

	taskActionSelectFocus() {
		this.showTaskActionSelect = true;
		if (this.selectTaskActionType)
			this.selectTaskActionType.setFocus();
	}

	taskActionSelectFocusChange(focus: boolean) {
		if (!focus) this.showTaskActionSelect = false;
		if (this.selectTaskActionType)
			this.selectTaskActionType.value = '';
	}

	addTaskAction(actionType: number) {
		let taskAction = new TaskActionModel;
		taskAction.type = actionType;
		this.newTaskAction = taskAction;
		this.createNewTaskAction.emit(this.newTaskAction);
	}
}